// A rejected answer is not an expired session. In particular, generic 400s
// must stay on the question with Retry instead of sending users to code entry.
export function isAssessmentSessionError(error) {
  if (error?.code === 'ASSESSMENT_SESSION_REQUIRED') return true;
  const status = Number(error?.status || error?.response?.status || error?.error?.code
    || /^(401|404)\b/.exec(error?.message || '')?.[1]);
  if ([401, 404].includes(status)) return true;
  const message = [error?.message, error?.details, error?.response?.error?.message]
    .filter((value) => typeof value === 'string').join(' ');
  return status === 400 && /invalid session id|missing x-api-sessionid|session credentials are missing/i.test(message);
}

// One same-voucher recovery attempt; never create an anonymous replacement or
// bypass the completed-voucher email gate. A retry failure remains visible.
export async function requestWithAssessmentRecovery(request, recover) {
  try {
    return await request();
  } catch (error) {
    if (!isAssessmentSessionError(error)) throw error;
    const recovered = await recover();
    if (!recovered?.sessionId || !recovered?.sessionToken) {
      if (recovered?.reviewMode) error.reviewMode = recovered.reviewMode;
      throw error;
    }
    return request();
  }
}
